import Menu from '@admin/components/menu'
import PropTypes from 'prop-types'
import Modals from './modals'
import Pages from './pages'
import Posts from './posts'
import React from 'react'

class Navigation extends React.PureComponent {

  static propTypes = {
    device: PropTypes.object,
    website: PropTypes.object,
    onBack: PropTypes.func,
    onNavigate: PropTypes.func,
    onSettings: PropTypes.func
  }

  render() {
    return <Menu { ...this._getMenu()} />
  }

  _getMenu() {
    return {
      type: 'pointing',
      items: [
        { label: 'Pages', component: <Pages { ...this._getProps() } /> },
        { label: 'Blog', component: <Posts { ...this._getProps() } /> },
        { label: 'Modals', component: <Modals { ...this._getProps() } /> }
      ]
    }
  }

  _getPanel() {
    return {
      showHeader: false
    }
  }

  _getProps() {
    const { device, website, onNavigate, onSettings } = this.props
    return {
      device,
      website,
      onNavigate,
      onSettings
    }
  }

}

export default Navigation
